(function(){
  function initMarquee(root){
    if(root.dataset.luxInit==='1')return;
    var track=root.querySelector('[data-track]');
    if(!track)return;
    var originals=Array.prototype.slice.call(track.children);
    if(!originals.length)return;
    root.dataset.luxInit='1';
    var gap=parseInt(root.dataset.gap,10)||0;
    var pvD=parseInt(root.dataset.pvDesktop,10)||5;
    var pvM=parseInt(root.dataset.pvMobile,10)||2;
    var spD=parseFloat(root.dataset.speedDesktop)||0;
    var spM=parseFloat(root.dataset.speedMobile)||0;
    var dir=root.dataset.direction==='right'?1:-1;
    var pauseHover=root.dataset.pauseHover==='true';
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var designMode=window.Shopify&&window.Shopify.designMode;
    var mq=window.matchMedia('(max-width: 749px)');
    var origHTML=originals.map(function(n){return n.outerHTML;}).join('');
    var x=0,unitWidth=0,raf=null,last=0,dragging=false,dragStartX=0,dragBaseX=0,moved=false,hoverPause=false;

    function perView(){return mq.matches?pvM:pvD;}
    function speed(){return mq.matches?spM:spD;}

    function build(){
      var W=root.clientWidth||1;
      var pv=Math.max(1,perView());
      var slideW=Math.max(1,(W-(pv-1)*gap)/pv);
      var repeats=Math.max(3,Math.ceil(pv/originals.length)+1);
      var html='';
      for(var r=0;r<repeats*2;r++){html+=origHTML;}
      track.innerHTML=html;
      var els=Array.prototype.slice.call(track.children);
      els.forEach(function(el){el.style.flex='0 0 '+slideW+'px';el.style.width=slideW+'px';el.style.marginRight=gap+'px';});
      unitWidth=originals.length*repeats*(slideW+gap);
      x=(dir===1)?-unitWidth:0;
      apply();
    }
    function apply(){track.style.transform='translateX('+x+'px)';}
    function wrap(){
      if(unitWidth<=0)return;
      while(-x>=unitWidth)x+=unitWidth;
      while(x>0)x-=unitWidth;
    }
    function frame(ts){
      if(!last)last=ts;
      var dt=(ts-last)/1000;last=ts;
      if(dt>0.1)dt=0.1;
      var v=speed();
      if(!dragging&&!hoverPause&&v>0&&!reduce){x+=dir*v*dt;wrap();apply();}
      raf=requestAnimationFrame(frame);
    }
    function start(){if(raf)return;last=0;raf=requestAnimationFrame(frame);}

    function onDown(e){dragging=true;moved=false;dragStartX=(e.touches?e.touches[0].clientX:e.clientX);dragBaseX=x;}
    function onMove(e){if(!dragging)return;var cx=(e.touches?e.touches[0].clientX:e.clientX);var d=cx-dragStartX;if(Math.abs(d)>3)moved=true;x=dragBaseX+d;wrap();apply();}
    function onUp(){dragging=false;}
    track.addEventListener('touchstart',onDown,{passive:true});
    track.addEventListener('touchmove',onMove,{passive:true});
    track.addEventListener('touchend',onUp);
    track.addEventListener('mousedown',function(e){e.preventDefault();onDown(e);});
    window.addEventListener('mousemove',onMove);
    window.addEventListener('mouseup',onUp);
    track.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();}},true);
    track.addEventListener('dragstart',function(e){e.preventDefault();});
    if(pauseHover){root.addEventListener('mouseenter',function(){hoverPause=true;});root.addEventListener('mouseleave',function(){hoverPause=false;});}
    document.addEventListener('visibilitychange',function(){hoverPause=document.hidden;});

    var rt=null;
    window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(build,200);});
    if(mq.addEventListener){mq.addEventListener('change',build);}else{mq.addListener(build);}

    build();start();
  }
  function initAll(scope){(scope||document).querySelectorAll('[data-lux-marquee]').forEach(initMarquee);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){initAll(document);});}else{initAll(document);}
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();
